<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import {
  CommissionStatisticActionTypes,
  useCommissionStatisticStore
} from '@/modules/statistic/stores/statistic.commisstion.store.ts'
import { computed, onMounted } from 'vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import StatisticWidget from '@/onenetwork/components/widgets/StatisticWidget.vue'
import CommissionByCategoryChart from '@/modules/statistic/components/CommissionByCategoryChart.vue'
import DebugJson from '@/onenetwork/components/debug/DebugJson.vue'
import CommissionGrowthChart from '@/modules/statistic/components/CommissionGrowthChart.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'

const statisticStore = useCommissionStatisticStore()

const filter = computed(() => {
  return statisticStore.filter
})
const widgets = computed(() => {
  return statisticStore.widgets
})
const charts = computed(() => {
  return statisticStore.chart
})

const handleUpdateFilter = (filter: any) => {

  statisticStore.setFilter(filter)
}

const lb_loading = computed(()=>{
  return statisticStore.leaderboard.action_type !== CommissionStatisticActionTypes.FETCH_SUCCESS
})
const lb_TableConfig = computed(()=>{
  return statisticStore.leaderboard.tableConfig
})
const lb_pageSize = computed(()=>{
  return statisticStore.leaderboard.pageSize
})
const lb_page = computed(()=>{
  return statisticStore.leaderboard.page
})
const lb_dataSource = computed(()=>{
  return statisticStore.leaderboard.data
})
const lb_handleChangePage = (page: number) => {
  statisticStore.changePageLeaderBoard(page)

}
const lb_handleChangePageSize = (pageSize: number) => {
  statisticStore.changePageSizeLeaderBoard(pageSize)
}



const list_loading = computed(()=>{
  return statisticStore.listing.action_type !== CommissionStatisticActionTypes.FETCH_SUCCESS
})
const list_TableConfig = computed(()=>{
  return statisticStore.listing.tableConfig
})
const list_pageSize = computed(()=>{
  return statisticStore.listing.pageSize
})
const list_page = computed(()=>{
  return statisticStore.listing.page
})
const list_dataSource = computed(()=>{
  return statisticStore.listing.data
})
const list_handleChangePage = (page: number) => {
  statisticStore.changePageLeaderBoard(page)

}
const list_handleChangePageSize = (pageSize: number) => {
  statisticStore.changePageSizeLeaderBoard(pageSize)
}

onMounted(()=>{
  statisticStore.fetchSummary()
  statisticStore.fetchChartData()
  statisticStore.fetchLeaderBoard()
  statisticStore.fetchListingData()
})
</script>

<template>
  <dashboard-layout currentRoute="reports/broker-commissions" page-title="Thống kê • Hoa hồng môi giới ">
    <filter-list
      :filter="filter"
      @update:filter="handleUpdateFilter"
    />
    <div class="flex w-full mb-5">
      <Panel class="w-full" header="Tổng quan" toggleable>
        <div class="flex flex-col md:flex-row md:flex-wrap gap-3">
          <statistic-widget
            icon="famicons:bar-chart-sharp"
            title="Tổng doanh thu"
            :current-value="widgets?.revenueThisMonth?.value"
            value-unit="đ"
            :growth-value="widgets?.revenueThisMonth?.growth"
            growth-value-unit="%"
            growth-description="so với tháng trước"
          />

          <statistic-widget
            icon="famicons:bar-chart-sharp"
            title="Tổng hoa hồng"
            :current-value="widgets?.commissionThisMonth?.value"
            value-unit="đ"
            :growth-value="widgets?.commissionThisMonth?.growth"
            growth-value-unit="%"
            growth-description="so với tháng trước"
          />

          <statistic-widget
            icon="famicons:bar-chart-sharp"
            title="Tổng hoa hồng công ty"
            :current-value="widgets?.commissionCompanyThisMonth?.value"
            value-unit="đ"
            :growth-value="widgets?.commissionCompanyThisMonth?.growth"
            growth-value-unit="%"
            growth-description="so với tháng trước"
          />

          <statistic-widget
            icon="famicons:bar-chart-sharp"
            title="Tổng hoa hồng cho môi giới"
            :current-value="widgets?.commissionBrokerThisMonth?.value"
            value-unit="đ"
            :growth-value="widgets?.commissionBrokerThisMonth?.growth"
            growth-value-unit="%"
            growth-description="so với tháng trước"
          />

          <statistic-widget
            icon="famicons:bar-chart-sharp"
            title="Tổng HH cho MG đã chi trả"
            :current-value="widgets?.paidCommissionBrokerThisMonth?.value"
            value-unit="đ"
            :growth-value="widgets?.paidCommissionBrokerThisMonth?.growth"
            growth-value-unit="%"
            growth-description="so với tháng trước"
          />

        </div>
      </Panel>
    </div>
    <div class="flex w-full mb-5 gap-3">
      <div class="flex-2">
        <Panel toggleable header="Biểu đồ tăng trưởng">
          <commission-growth-chart :data="charts.growthData"/>
        </Panel>
      </div>
      <div class="flex-1">
       <Panel toggleable header="Hoa hồng theo danh mục BDS">
         <commission-by-category-chart :data="charts.commissionByCategory"/>
       </Panel>
      </div>
    </div>
    <div class="flex w-full mb-5 gap-3">
      <div class="flex-2">
        <Panel toggleable header="Top hoa hồng môi giới">
          <data-table
            :loading="lb_loading"
            :tableConfig="lb_TableConfig"
            :page-size="lb_pageSize"
            :page="lb_page"
            :total-page="lb_dataSource?.totalPage || 0"
            :total-records="lb_dataSource?.totalRecords || 0"
            :data="lb_dataSource?.list || []"
            :display-config="false"
            primaryField="code"
            @page-changed="lb_handleChangePage"
            @pagesize-changed="lb_handleChangePageSize"
          />
        </Panel>
      </div>
      <div class="flex-3">
        <Panel toggleable header="Danh sách hoa hồng">
          <data-table
            :loading="list_loading"
            :tableConfig="list_TableConfig"
            :page-size="list_pageSize"
            :page="list_page"
            :total-page="list_dataSource?.totalPage || 0"
            :total-records="list_dataSource?.totalRecords || 0"
            :data="list_dataSource?.list || []"
            primaryField="code"
            @page-changed="list_handleChangePage"
            @pagesize-changed="list_handleChangePageSize"
          />
        </Panel>
      </div>
    </div>
  </dashboard-layout>
</template>

<style scoped>

</style>
